import React from 'react';
import { Button, Header, Icon, Modal } from 'semantic-ui-react';
import { redirectToLogin } from '../../modules/utils';

export default function TimeoutModal(props: { open: boolean }) {
    return (
        <Modal open={props.open} basic size="small">
            <Header icon="browser" content="Session Expired" />
            <Modal.Content>
                <h3>Your session has expired</h3>
            </Modal.Content>
            <Modal.Actions>
                <Button color="green" onClick={redirectToLogin} inverted>
                    <Icon name="arrow right" /> &nbsp; Login
                </Button>
            </Modal.Actions>
        </Modal>
    );
}



// WEBPACK FOOTER //
// ./components/molecules/TimeoutModal.jsx